import { render, staticRenderFns } from "./RecommendTeacherButton.vue?vue&type=template&id=c90ff1fa&scoped=true&"
import script from "./RecommendTeacherButton.vue?vue&type=script&lang=js&"
export * from "./RecommendTeacherButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90ff1fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VDialog,VTextarea})
